import worldMap from '../core/map';
import halo from '../core/map/halo';
import { pinBuilder } from '../core/map/pinBuilder';
import templates from '../core/templates';
import translate from '../core/tools/translate';
import environment from '../environment';
import Leaflet from './Leaflet';

class CitiesLayer {
    constructor (currentMap) {
        const clusterImage = new Image();
        clusterImage.src = `${environment.get('IMAGES_HOST')}/icon_marker_points.png`;

        const onClick = (feature, layer) => {
            if (halo.hasBubbles(feature.properties.Id, currentMap)) return;

            halo.create([{
                check () {
                    return worldMap.getContext().active();
                },
                feature,
                layer,
                icon: 'icon_bubble_routing',
                position: 'top',
                startPosition: '0px',
                title: translate('Action.Routing'),
                click () {
                    const e = { latlng: layer.getLatLng() };

                    if (worldMap.getContext().hasPoint(e.latlng)) {
                        return;
                    }

                    if (worldMap.getContext().active()) {
                        return worldMap.getContext().setEndPosition(e);
                    } else {
                        return worldMap.getContext().setStartPosition(e);
                    }
                }

            }], {
                radius: 50,
                offset: [0, 35]
            });
        };

        const clusterTemplate = (cluster) => {
            const data = { value: cluster.getChildCount() };

            return pinBuilder.create.pin.imageWithValue(data, clusterImage);
        };

        return new Leaflet.GeoJSONLayer({
            map: currentMap,
            remote: {
                method: 'POST',
                url: `${environment.get('API_HOST')}/localidade/ObterCidadesSede`,
                params: {
                    startDate: '201601',
                    endDate: '201612',
                    minDemography: 1000000,
                    maxDemography: 100000000,
                    minDomicilesTarget: 0,
                    maxDomicilesTarget: 100000000,
                    minRegistrations: 0,
                    maxRegistrations: 100000000,
                    outputFormat: 1,
                    target: 11
                }
            },
            scaleRange: [9, 20],
            showAll: false,
            // autofocus: false
            uniqueField: 'id',
            sort: 'name',
            click: onClick,
            filter: {
                location: true
            },
            label: {
                template (properties) {
                    return templates('map-layer-city-label', properties);
                }
            },
            type: 'decluster',
            symbology: {
                type: 'single',
                cluster: {
                    template: clusterTemplate
                },
                style: {
                    icon: {
                        iconUrl: `${environment.get('IMAGES_HOST')}/pin_location.png`,
                        iconSize: [18, 18],
                        iconAnchor: [9, 9],
                        labelAnchor: [9, 0]
                    },
                    riseOnHover: true
                }
            }
        });
    }
}

export default CitiesLayer;



// WEBPACK FOOTER //
// ./src/scripts/layers/CitiesLayer.js